import Vue from "vue"
import GalleryList from "../../vue-components/GalleryList.vue"

const gallery = () => {
	if (document.querySelector("#gallery")) {
		Vue.config.productionTip = false
		Vue.config.devtools = false

		new Vue({
			el: "#gallery",
			render: (h) => h(GalleryList),
		})
	}
}

export default gallery
